import React from 'react';
import PropTypes from 'prop-types';
import { SnackbarProvider } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { injectIntl } from 'react-intl';

import SharedSnackbarContent from './SharedSnackbar.component';

const styles = theme => ({
  variantSuccess: {
    color: 'white',
  },
  variantError: {
    color: 'white',
  },
  variantWarning: {
    color: 'black',
  },
  variantInfo: {
    color: 'white',
  }
});

/**
 * See https://github.com/iamhosseindhv/notistack
 * for more details on SnackbarProvider
 */
const SharedSnackbarProvide = ({ classes, children, ...props }) => (
  <SnackbarProvider
    {...props}
    action={[
      <IconButton key="close" color="inherit">
        <Close />
      </IconButton>,
    ]}
    classes={{
      variantSuccess: classes.variantSuccess,
      variantError: classes.variantError,
      variantWarning: classes.variantWarning,
      variantInfo: classes.variantInfo,
    }}
  >
    <SharedSnackbarContent>
      {children}
    </SharedSnackbarContent>
  </SnackbarProvider>
);

SharedSnackbarProvide.propTypes = {
  children: PropTypes.node.isRequired,
  maxSnack: PropTypes.number,
};

SharedSnackbarProvide.defaultProps = {
  maxSnack: 4,
};

export const SharedSnackbarProvider = withStyles(styles)(injectIntl(SharedSnackbarProvide));
